// src/components/HeroSlider.jsx
import React, { useState, useEffect } from "react";
import "../css/HeroSlider.css";

const slides = [
  require("../assets/peony-square-gg-homestay-project.jpg"),
  require("../assets/Gemini_Generated_Image_2nhp022nhp022nhp.png"),
  require("../assets/Gemini_Generated_Image_oind8toind8toind.png"),
];

export default function HeroSlider() {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, 3000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="hero-slider">
      {slides.map((img, i) => (
        <div
          className={`slide ${i === current ? "active" : ""}`}
          key={i}
          style={{ backgroundImage: `url(${img})` }}
        ></div>
      ))}

      {/* Small Dots */}
      <div className="slider-dots">
        {slides.map((_, i) => (
          <span
            key={i}
            className={`dot ${i === current ? "active" : ""}`}
            onClick={() => setCurrent(i)}
          ></span>
        ))}
      </div>
    </div>
  );
}
